import React, { useState, useEffect } from "react";
import { Progress } from "reactstrap";

const PlanDetails = ({
  history,
  teamLimit,
  teamCount,
  blenderCredits,
  paymentDetails
}) => {
  const isBlenderCredits = blenderCredits !== undefined;
  const noDetails = paymentDetails.list;
  const [barPercentage, setBarPercentage] = useState(0);

  const getTeammatesOnPlan = () => {
    if (noDetails || teamCount <= teamLimit) {
      return `${teamCount} of ${teamCount}`;
    } else {
      return `${teamLimit} of ${teamCount}`;
    }
  };

  useEffect(() => {
    if (noDetails || teamCount <= teamLimit) setBarPercentage(100);
    else setBarPercentage(Math.round((teamLimit / teamCount) * 100));
  }, [noDetails, teamCount, teamLimit]);

  return (
    <section className="plan-details">
      <div className="plan-type">
        <p>{noDetails ? "free" : "team plan"}</p>
        <button
          className="upgrade-btn"
          onClick={() => history.push("/pricing_page")}
        >
          {noDetails ? "Upgrade Plan" : "Change Plan"}
        </button>
      </div>
      <h4 className="plan-title">{noDetails ? "Play Plan" : "Perform Plan"}</h4>
      <p className="plan-desc">
        You’re on the free Play plan, so you have to upcoming charges.
      </p>
      <h4 className="cost">{`$${
        noDetails ? "0" : (paymentDetails.unit_price / 100).toFixed(2)
      } per ${
        paymentDetails.item_price_id === "Platform-Only-USD-Monthly"
          ? "month"
          : "year"
      }`}</h4>
      <div className="plan-progress">
        <div className="plan-progress-text">
          <h3 className="title">Teammates on Plan</h3>
          <p>{getTeammatesOnPlan()}</p>
        </div>
        <Progress value={barPercentage}></Progress>
        <p className="remaining">
          {`${
            noDetails
              ? "0 Plans Remaining"
              : teamCount - teamLimit + " Plans Remaining"
          }`}
        </p>
      </div>
      <div className="plan-progress">
        <div className="plan-progress-text">
          <h3 className="title">Team Blender Credits</h3>
          <p>
            {isBlenderCredits
              ? blenderCredits + " of " + blenderCredits
              : "0 of 0"}
          </p>
        </div>
        <Progress value="100"></Progress>
        <p className="remaining">
          {isBlenderCredits ? blenderCredits : "0"} Remaining
        </p>
      </div>
    </section>
  );
};

export default PlanDetails;
